import { render, staticRenderFns } from "./Detalles.vue?vue&type=template&id=241e8edd&scoped=true&"
import script from "./Detalles.vue?vue&type=script&lang=js&"
export * from "./Detalles.vue?vue&type=script&lang=js&"
import style0 from "./Detalles.vue?vue&type=style&index=0&id=241e8edd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "241e8edd",
  null
  
)

export default component.exports